import React from 'react';
import { Link } from 'react-router-dom';
import './EventDelineatingMethods.css';

const methods = [
  {
    number: '01',
    title: 'Hydrograph Separation',
    description:
      'Uses digital filtering techniques to distinguish rapid event flow from steady base flow in drainage datasets.',
  },
  {
    number: '02',
    title: 'Event Flow Weighted Concentration',
    description:
      'Calculates nutrient or pollutant concentrations weighted by event-flow volume for environmental impact assessment.',
  },
  {
    number: '03',
    title: 'Water Table Depth Analysis',
    description:
      'Processes sensor observations to estimate average water-table depth and support drainage management decisions.',
  },
  {
    number: '04',
    title: 'Soil Temperature Modeling',
    description:
      'Connects soil-temperature measurements with flow dynamics, seasonal conditions, and microbial activity.',
  },
];

const EventDelineatingMethods = () => {
  return (
    <main className="methods-page">
      <div className="methods-shell">
        <header className="methods-header">
          <p className="methods-eyebrow">Analysis methodology</p>

          <h1>Event Delineating Methods</h1>

          <p className="methods-introduction">
            Understand how event-driven drainage flow is separated from
            underlying base flow using reproducible analytical methods.
          </p>

          <div className="methods-actions">
            <Link className="methods-primary-action" to="/perform-analysis">
              Perform analysis
              <span aria-hidden="true">→</span>
            </Link>

            <a className="methods-secondary-action" href="#methods">
              Explore methods
            </a>
          </div>
        </header>

        <section className="overview-section" aria-labelledby="overview-title">
          <div className="section-heading">
            <span>Overview</span>
            <h2 id="overview-title">
              Turning drainage observations into meaningful events
            </h2>
          </div>

          <div className="overview-content">
            <p>
              The Event and Base Flow Delineator uses analytical algorithms to
              separate event-driven flow from persistent base flow in
              subsurface drainage fields.
            </p>

            <p>
              These methods help researchers characterize hydrologic events,
              estimate flow-weighted concentrations, and study relationships
              among drainage, water-table depth, and soil temperature.
            </p>
          </div>
        </section>

        <section
          className="methods-section"
          id="methods"
          aria-labelledby="methods-title"
        >
          <div className="section-heading">
            <span>Core methods</span>
            <h2 id="methods-title">A focused analytical workflow</h2>
          </div>

          <div className="methods-grid">
            {methods.map((method) => (
              <article className="method-card" key={method.number}>
                <span className="method-number">{method.number}</span>
                <h3>{method.title}</h3>
                <p>{method.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="requirements-section">
          <div>
            <p className="methods-eyebrow">Before you begin</p>
            <h2>Prepare your drainage dataset</h2>
            <p>
              Upload a CSV file containing a timestamp and flow-rate column.
              Environmental measurements such as nutrient concentration,
              water-table depth, and soil temperature may also be included.
            </p>
          </div>

          <Link className="requirements-action" to="/perform-analysis">
            Open analysis tools
            <span aria-hidden="true">→</span>
          </Link>
        </section>
      </div>
    </main>
  );
};

export default EventDelineatingMethods;